import { AdminPermission } from '@tassat/common-definitions';
import {
    ACG as ACGIcon,
    Alerts as AlertsIcon,
    ApiPair as ApiPairIcon,
    Firms as FirmsIcon,
    HandshakeIcon,
    Messages as MessagesIcon,
    TransactionHistory as TransactionHistoryIcon,
    Users as UsersIcon
} from '@tassat/icon';

import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const getAdminPermissionsByFeatures = (muiTheme: ApplicationMuiTheme): AdminPermission[] => {
    const {
        id: bankApiId,
        pageName: bankApiName,
        urlPath: bankApiUrl
    } = muiTheme.app.clientTheme.bankApi.permissionHelper;

    const tokenPermissions: AdminPermission[] = [
        {
            id: 'Firms',
            name: 'Manage Firms',
            url: '/admin/firms',
            Icon: FirmsIcon,
            permission: ['IsManageFirmAllowed'],
            notificationsAllowed: true,
            permittedRoles: [
                'Super Admin',
                'Bank Ops',
                'Client Service'
            ]
        },
        {
            id: 'ViewFirms',
            name: 'View Firms',
            url: '/admin/firms',
            Icon: FirmsIcon,
            permission: ['IsManageFirmViewOnlyAllowed'],
            permittedRoles: [
                'Super Admin',
                'Private Client Group',
                'Bank Ops Supervisor'
            ]
        },
        {
            id: 'Transactions',
            name: 'Transaction History',
            url: '/admin/history',
            Icon: TransactionHistoryIcon,
            permission: [
                'IsTransactionHistoryAllowed',
                'IsTransactionHistoryViewOnlyAllowed'
            ],
            permittedRoles: [
                'Super Admin',
                'Bank Ops Supervisor',
                'Bank Ops',
                'Client Service',
                'Private Client Group' //View only
            ]
        },
        {
            id: 'Alerts',
            name: 'Alerts',
            url: '/admin/alerts',
            Icon: AlertsIcon,
            permission: ['IsViewAlertsAllowed'],
            permittedRoles: [
                'Super Admin',
                'Bank Ops Supervisor',
                'Bank Ops',
                'Client Service'
            ]
        },
        {
            id: 'AdminUsers',
            name: 'Manage Admin Users',
            url: '/admin/users',
            Icon: UsersIcon,
            notificationsAllowed: true,
            permission: ['IsManageAdminUsersAllowed'],
            permittedRoles: [
                'Super Admin',
                'Help Desk'
            ]
        },
        // CUST API IS POST POC
        // {
        //     id: bankApiId,
        //     name: bankApiName,
        //     url: `/admin/${bankApiUrl}`,
        //     Icon: FISIcon,
        //     permission: ['IsCustodianAPIAllowed'],
        //     permittedRoles: [
        //         'Super Admin',
        //         'Bank Ops',
        //         'Bank Ops Supervisor',
        //         'Client Service'
        //     ]
        // },
        {
            id: 'ACG',
            name: 'ACG Table',
            url: '/admin/acg',
            Icon: ACGIcon,
            permission: ['IsACGNumberMaintenanceAllowed'],
            permittedRoles: [
                'Super Admin',
                'Help Desk'
            ]
        },
        {
            id: 'APIFirms',
            name: 'API Firms',
            url: '/admin/firms',
            Icon: FirmsIcon,
            permission: ['IsAPIScreensAllowed'],
            permittedRoles: [
                'Super Admin',
                'API Ops'
            ]
        },
        {
            id: 'APIConnections',
            name: 'API Connections',
            url: '/admin/apiConnections',
            Icon: ApiPairIcon,
            permission: ['IsAPIScreensAllowed'],
            permittedRoles: [
                'Super Admin',
                'API Ops'
            ]
        },
        {
            id: 'BalanceHeader',
            name: 'Balance Header',
            permission: ['IsSeeingBalanceHeaderAllowed'],
            permittedRoles: [
                'Super Admin',
                'Bank Ops Supervisor',
                'Bank Ops'
            ]
        },
        {
            id: 'ClientMessages',
            name: 'Messages',
            url: '/admin/messages',
            Icon: MessagesIcon,
            permission: ['IsTransactionHistoryAllowed'],
            permittedRoles: [
                'Super Admin',
                'Bank Ops Supervisor',
                'Bank Ops'
            ]
        },
        {
            id: 'Collateral',
            name: 'Collateral Management',
            url: '/admin/collateral',
            Icon: HandshakeIcon,
            permission: [
                'IsTransactionHistoryAllowed',
                'IsTransactionHistoryViewOnlyAllowed'
            ],
            permittedRoles: [
                'Super Admin',
                'Bank Ops Supervisor',
                'Bank Ops'
            ]
        }
    ];

    return tokenPermissions;
};